import React from 'react'
import { getTimelineStatus } from 'utils/helperMethods';
import BusinessTab from 'components/Onboarding/Mle/BusinessTab';
import UobTab from 'components/Onboarding/Mle/UobTab';
import { first } from 'lodash';
import { BUSINESS_SECTION_TYPE_MLE, MLE_CREATE_FORM_NAME } from 'components/Onboarding/Mle/BusinessTab/contants';
import { UBO_CREATE_FORM_NAME, UBO_SECTION_TYPE } from 'components/Onboarding/Mle/UobTab/constant';
import { BUSINESSDETAILS, EDITABLE, UBODETAILS } from '../constants';
import { MOCK_API_VALUE } from 'utils/constants/commonValues';
import { mapCheckerRemarksKeyWithNames } from 'components/Onboarding/Mle/mle.utils';

const getDefaultSecurityValue = securityValue => {
    if (securityValue) {
        const allSelectedValues = [];
        const values = securityValue;
        if (typeof values === 'string' || values instanceof String) {
            return values;
        }
        for (const property in values) {
            if (Object.prototype.hasOwnProperty.call(values, property)) {
                if (values[property]) {
                    allSelectedValues.push(property);
                }
            }
        }
        return first(allSelectedValues);
    }
    return '';
};


const formatIntegrationInitialData = draftData => {
    if (draftData && draftData.data) {
        const draftDataValue = { ...draftData.data };
        draftDataValue.security = getDefaultSecurityValue(
            draftDataValue.security
        );
        return draftDataValue;
    }
    return {};
};



const getPath = (processStepsList, idx, maxLen) => {
    if (idx >= 0 && idx < maxLen) {
        return processStepsList[idx].path;
    }
    return null; 
}

const baseUrl = '/mle-onboarding/';


const mleOnBoarding = (formEvents, routePath, permissions = {}, pathType, pathid, uniqueIdentifier, initialIntentId) => {
    
    
    // const mleOnboardingPermissions = permissions.mle_onboarding
    //     ? permissions.mle_onboarding
    //     : [];

    // // Define a list of onboarding process steps with their configurations.
    const processStepsList = [
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                let checkerRemarks = undefined;
                if (props?.basicSectionData?.mleUpdateConfig) {
                    checkerRemarks = {};
                    Object.entries(props?.basicSectionData?.mleUpdateConfig).map(([key, value]) => {
                        
                        checkerRemarks[mapCheckerRemarksKeyWithNames(key)] = {
                            status: EDITABLE,
                            docCategory: value?.docCategory || [],
                        }
                    })
                }
                
                
                return (
                    <BusinessTab
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={draftData || {}}
                        uniqueIdentifier={uniqueIdentifier}
                        initialIntentId={initialIntentId}
                        checkerRemarks={checkerRemarks}
                    />
                );
            },
            name: 'Business Details',
            sectionType: BUSINESS_SECTION_TYPE_MLE,
            nextPath: (pathid) ? `${baseUrl}${pathType}/${UBODETAILS}/${pathid}` : `${baseUrl}${pathType}/${UBODETAILS}`,
            path: (pathid) ? `${baseUrl}${pathType}/${BUSINESSDETAILS}/${pathid}` : `${baseUrl}${pathType}/${BUSINESSDETAILS}`,
            previousPath: '/mle-onboarding',
            status: (MOCK_API_VALUE) ? 'Open' : formEvents[`${MLE_CREATE_FORM_NAME}status`],
            tabId: 1,
            permission: 'create_merchant',
        },
        {
            component(props) {
                
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                
                let checkerRemarks = undefined;
                if (draftData) {
                    props.initialValues = draftData;
                    
                    if (props?.basicSectionData?.mleUpdateConfig) {
                        checkerRemarks = {};
                        for (let i = 0; i < draftData?.uboDetails?.length; i++) {
                            Object.entries(props?.basicSectionData?.mleUpdateConfig).map(([key, value]) => {
                                
                                checkerRemarks[mapCheckerRemarksKeyWithNames(`uboDetails.${i}.${key}`)] = {
                                    status: EDITABLE,
                                    docCategory: value?.docCategory || [],
                                }
                            })
                        }
                        console.log("checker Remarks ubo tab", checkerRemarks);
                    }
                }
                
                return (
                    <UobTab
                        {...props} // eslint-disable-next-line react/prop-types
                        nextPath={props.nextPath}
                        uniqueIdentifier={uniqueIdentifier}
                        initialIntentId={initialIntentId}
                        checkerRemarks={checkerRemarks}
                    />
                );
            },
            name: 'Ownership Details',
            sectionType: UBO_SECTION_TYPE,
            nextPath: `/mle-onboarding`,
            path: (pathid) ? `${baseUrl}${pathType}/${UBODETAILS}/${pathid}` : `${baseUrl}${pathType}/${UBODETAILS}`,
            previousPath: (pathid) ? `${baseUrl}${pathType}/${BUSINESSDETAILS}/${pathid}` : `${baseUrl}${pathType}/${BUSINESSDETAILS}`,
            status: (MOCK_API_VALUE) ? 'Open' : formEvents[`${UBO_CREATE_FORM_NAME}status`],
            tabId: 2,
            permission: 'integration',
        },
    ];

    return processStepsList;

    // sorting the fields
    // const sortedField = orderBy(fields, ['order'], ['asc']).filter(
    //     field => field.mandatory
    // );

    // if (
    //     mleOnboardingPermissions &&
    //     mleOnboardingPermissions.length > 0
    // ) {
    //     // eslint-disable-next-line array-callback-return
    //     let sortedFieldMapped = sortedField.map((item, index) => {
    //         const sectionData = processStepsList.find(
    //             section => section.sectionType === item.sectionType
    //         );
    //         if (sectionData && sectionData.sectionType === item.sectionType) {
    //             let maxLen = processStepsList.length;
    //             sectionData.nextPath = getPath(processStepsList, index+1, maxLen);
    //             sectionData.previousPath = getPath(processStepsList, index-1, maxLen);

    //             return { ...item, ...sectionData };
    //         }
    //     });

    //     sortedFieldMapped = sortedFieldMapped.filter(function(element) {
    //         return element !== undefined;
    //     });

    //     if (sortedFieldMapped && sortedFieldMapped.length > 0) {
    //         sortedFieldMapped[sortedFieldMapped.length - 1].nextPath = null;
    //     }

    //     return sortedFieldMapped;
    // }
    return [];
};


export default mleOnBoarding;
 